// Адрес чата поддержки MAX для центра помощи и экранов без компании.
export function getSupportMaxUrl() {
  return (process.env.VUE_APP_SUPPORT_MAX_BOT_URL || "").trim();
}
